import { useCallback, useState } from "react";
import { TranslationService } from "../../../../services/TranslationService";
import AIBillingService, {
  AIBillingDateRange
} from "../../../../services/AIBillingService";
import { ToastService } from "../../../shared/bootstrap/Toast";

export async function exportUsagePeriod(
  from: string,
  to: string
): Promise<boolean> {
  const result = await AIBillingService.exportUsage({ from, to });
  return !(result instanceof Error);
}

export async function exportPaymentsPeriod(
  from: string,
  to: string
): Promise<boolean> {
  const result = await AIBillingService.exportPayments({ from, to });
  return !(result instanceof Error);
}

export function useUsageExport(range: AIBillingDateRange) {
  const [exporting, setExporting] = useState(false);
  const { from, to } = range;

  const onExport = useCallback(async () => {
    if (!from || !to) {
      return;
    }
    setExporting(true);
    const succeeded = await exportUsagePeriod(from, to);
    setExporting(false);

    if (!succeeded) {
      ToastService.showToast(
        TranslationService.translate.AIExportFailed,
        undefined,
        "danger"
      );
    }
  }, [from, to]);

  return { exporting, onExport };
}

export function useRechargesExport(range: AIBillingDateRange) {
  const [exporting, setExporting] = useState(false);
  const { from, to } = range;

  const onExport = useCallback(async () => {
    if (!from || !to) {
      return;
    }
    setExporting(true);
    const succeeded = await exportPaymentsPeriod(from, to);
    setExporting(false);

    if (!succeeded) {
      ToastService.showToast(
        TranslationService.translate.AIExportFailed,
        undefined,
        "danger"
      );
    }
  }, [from, to]);

  return { exporting, onExport };
}
